export function getQuickSortAnimations(array) {
  const animations = [];

  const quickSort = (arr, low, high) => {
    if (low < high) {
      const pi = partition(arr, low, high);
      quickSort(arr, low, pi - 1);
      quickSort(arr, pi + 1, high);
    }
  };

  const partition = (arr, low, high) => {
    let pivot = arr[high];
    let i = low;

    for (let j = low; j < high; j++) {
      animations.push([j, high, 'compare']);
      if (arr[j] < pivot) {
        [arr[i], arr[j]] = [arr[j], arr[i]];
        animations.push([i, j, 'swap']);
        i++;
      }
    }
    [arr[i], arr[high]] = [arr[high], arr[i]];
    animations.push([i, high, 'swap']);
    return i;
  };

  quickSort(array, 0, array.length - 1);
  return animations;
}
